import { createFileRoute } from '@tanstack/react-router';
import { EventDetailPage } from '../../features/community';

export const Route = createFileRoute('/portal/events/$id')({
  component: function EventRoute() {
    const { id } = Route.useParams();
    return <EventDetailPage id={id} />;
  },
});
